(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // TOBS: the Trustpilot bootstrap only initialises the widgets present at
  // page load. Filtering, sorting and infinite scroll replace or append
  // product cards, whose .trustpilot-widget nodes arrive without an iframe
  // and would otherwise stay empty, so hand them to the loader again.
  const resultsList = document.querySelector('results-list');
  if (resultsList) {
    let scheduled = false;
    const loadWidgets = () => {
      scheduled = false;
      if (!window.Trustpilot) return;
      for (const widget of resultsList.querySelectorAll('.trustpilot-widget:not(:has(iframe))')) {
        window.Trustpilot.loadFromElement(widget, true);
      }
    };
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(loadWidgets);
    }).observe(resultsList, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
